import { useRevalidator, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import RankingRuleEditFormWrapper from 'components/RankingRule/RankingRuleEditFormWrapper';
import PreviewProductWall from 'components/RankingRule/PreviewProductWall';
import Loader from 'components/Loader';
import { QUERY_KEYS } from 'constants/index';
import RankingClient from '../../clientAPI/ranking';

export default function EditRankingRule() {
  const revalidator = useRevalidator();
  const { ruleId } = useParams();

  const ruleQuery = {
    queryKey: [QUERY_KEYS.RANKING_RULE_LIST, ruleId],
    queryFn: async () => {
      return RankingClient.getRules({ ruleId });
    },
    staleTime: Infinity,
    onError: (err: { status: number }) =>
      err.status === 401 && revalidator.revalidate(),
  };
  const { status, data } = useQuery(ruleQuery);

  if (status === 'loading') {
    return <Loader />;
  }
  if (status === 'success' && data && data.data?.length > 0) {
    const rule = data.data[0];
    return (
      <div
        className='tw-grid tw-gap-2 tw-divide-x-2 tw-divide-white'
        style={{
          gridTemplateColumns: '1fr 3fr',
        }}
      >
        <div className='tw-py-2 tw-px-2'>
          <RankingRuleEditFormWrapper data={rule} />
        </div>
        <div className='tw-py-2 tw-px-4'>
          <PreviewProductWall
            ruleId={rule._id as string}
            ruleStatus={rule.status || ''}
            ruleStartDate={rule.startDate}
            ruleEndDate={rule.endDate}
            ruleTrigger={rule.trigger}
          />
        </div>
      </div>
    );
  }
  return <></>;
}
